import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "メール認証に失敗しました。", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("p", null, [
      _createTextVNode(" エラーコード: " + _toDisplayString(_ctx.state.errorList[_ctx.state.errorCode].code) + " ", 1),
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(_ctx.state.errorList[_ctx.state.errorCode].message), 1)
    ])
  ]))
}